import { useMemo } from "react";
import { combineLatest } from "rxjs";
import { distinctUntilKeyChanged, filter, map } from "rxjs/operators";
import { ContextPropsData, TIME_AXIS_WIDTH, ViewportSizeData } from "./calendar-context";
import { usePropsStream, useViewportStream } from "./hooks";
import { useSectionedGroups } from "./sectioned-groups-hook";

export const useGroupAxisRowMinWidth = () => {
    const props$ = usePropsStream();
    const viewport$ = useViewportStream();
    const categories$ = useSectionedGroups();

    return useMemo(
        () =>
            combineLatest([
                props$.pipe(filter<ContextPropsData>(Boolean), distinctUntilKeyChanged("minCategoryWidth")),
                viewport$.pipe(filter<ViewportSizeData>(Boolean), distinctUntilKeyChanged("width")),
                categories$,
            ]).pipe(
                map(([{ minCategoryWidth }, { width }, categories]) =>
                    Math.max(width - TIME_AXIS_WIDTH, minCategoryWidth * /* Find the longest group row */ categories.map((section) => section.length).sort((a, b) => b - a)[0])
                )
            ),
        [viewport$, categories$]
    );
};
